import styled from 'styled-components'

interface ICostSummaryRowStyledProps {}

export const CostSummaryRowStyled = styled.tr<ICostSummaryRowStyledProps>`
  display: contents;

  font-size: ${(props) => props.theme.typography.pxToRem(14)};

  th {
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
    text-align: left;
  }

  td {
    text-align: right;
    font-weight: ${(props) => props.theme.fontWeights.semibold};
  }
`
